import React from "react";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { formatDate } from "../../utils/commonFunctions";

type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: any[] | [];
};

const TimeSheetReportTable = ({ tableHeaders, data }: AppProps) => {
  const billableTypeStyle = () => {
    return {
      padding: "4px 12px",
      color: "#407EEE",
      background: "#E5EEFE",
      borderRadius: "16px",
      width: "80px",
    };
  };

  const nonBillableTypeStyle = () => {
    return {
      padding: "4px 12px",
      color: "#744bd1",
      background: "#ede6fc",
      borderRadius: "16px",
      width: "106px",
    };
  };
  return (
    <>
      {data?.length > 0 &&
        data?.map((timeSheetReportData: any) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "date") {
                    const formattedDate = formatDate(timeSheetReportData?.date);
                    return (
                      <td className="text-left">
                        {formattedDate}
                        {/* {timeSheetReportData?.date} */}
                      </td>
                    );
                  } else if (header?.value == "type") {
                    return (
                      <td className="text-left" >
                        <div style={{display:'flex' , flexDirection:'column' , gap:'13px'}}>
                        <span
                          style={
                            timeSheetReportData?.type === 2
                              ? nonBillableTypeStyle()
                              : billableTypeStyle()
                          }
                        >
                          {" "}
                          {timeSheetReportData?.type === 2
                            ? "Non Billable"
                            : "Billable"}
                        </span>
                        {timeSheetReportData?.shared_job ? 
                        <span style={{color:'#6e7491' , backgroundColor:"#eef1f4" , borderRadius: "16px" ,  width: "95px" ,   padding: "4px 8px"}}>{timeSheetReportData?.shared_job?"Shared Job" :''}</span>
                         :''} 
                        </div>
                      </td>
                    );
                  } else if (header?.value == "job_name") {
                    return (
                      <td className="text-left">
                        <span>{`${timeSheetReportData?.client_details.client_code?`(${timeSheetReportData?.client_details.client_code})`:""}`}</span> <span>{`${timeSheetReportData?.client_details.company_name?`${timeSheetReportData?.client_details.company_name}`:""}`}</span>
                        
                        <p style={{ color: "#6e7491" }}>{timeSheetReportData?.job?.code?<>{(timeSheetReportData?.job?.code ? `${timeSheetReportData?.job?.code}_` : "") + (timeSheetReportData?.job?.job_name ? `${timeSheetReportData?.job?.job_name}_` : "") + (timeSheetReportData?.period_ended ? `${formatDate(timeSheetReportData?.period_ended)}` : "")}</>:"--/--"}</p>
                      </td>
                    );
                  }
                  else if (header?.value === "start_time") {
                    const startTime = timeSheetReportData?.start_time;
                    const endTime = timeSheetReportData?.end_time;
                    const timeRange = `${startTime} - ${endTime}`;
                    return <td className="text-left">{timeRange}</td>;

                  } else if (header?.value == "time_difference") {
                    return <td>{timeSheetReportData?.time_difference?.toFixed(2)}</td>;

                  } else if (header?.value == "activity_code") {
                    return (
                      <td className="text-left">
                        {timeSheetReportData?.activity_code?timeSheetReportData?.activity_code:"--/--"}
                      </td>
                    );
                  } else if (header?.value == "comments") {
                    return (
                      <td className="text-left">
                        {timeSheetReportData?.comments}
                      </td>
                    );
                  }

                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default TimeSheetReportTable;
